<div class="layout-col full">
  <elder-table
    class="flex"
    matSort
    [data]="data"
    [interactionMode]="'selection'"
    [selectionVisible]="true"
    [selectionMultiEnabled]="false"
    (selectionSingleChange)="onRouteSelected($event)"
    [selectableEvaluatorFn]="notAlreadySelected"
  >
    <ng-container>
      <elder-data-toolbar *elderTableToolbar [canMore]="false" [canAdd]="false" [canRemove]="false">
        <ng-template elderToolbarContent="main">
          <elder-search-box
            dense
            placeholder="{{ 'shopfloor.workcenters.number' | translate }}"
            [elderSearchContext]="data.filter"
            queryKey="workCenterNumberSequence"
          >
          </elder-search-box>
        </ng-template>
      </elder-data-toolbar>
    </ng-container>

    <!--makespan column-->
    <ng-container matColumnDef="makeSpan">
      <th mat-header-cell elderNumberCell *matHeaderCellDef style="width: 15%" mat-sort-header>
        {{ 'context.make-span' | translate }}
      </th>
      <td mat-cell elderNumberCell *matCellDef="let route">
        <span>{{ showMakespan(route) ? (route.makeSpan | isoDuration: 'hh:mm') : '-' }}</span>
      </td>
    </ng-container>

    <!--description column-->
    <ng-container matColumnDef="workCenterNumberSequence">
      <th mat-header-cell mat-sort-header *matHeaderCellDef style="width: 80%">
        {{ 'context.description' | translate }}
      </th>
      <td mat-cell *matCellDef="let route">
        <app-item-schedule [route]="route" class="flex"></app-item-schedule>
      </td>
    </ng-container>
  </elder-table>

  <div class="layout-row place-start-center gap-sm p-sm">
    <button mat-button [disabled]="!(chosenRoute$ | async)" (click)="onSaveRoutes()">
      {{ 'actions.select' | translate }}
    </button>
  </div>
</div>
